export { default } from './SocialMediaIcon';
